import React from 'react'
import { Row } from 'antd'
import { Map, Marker, APILoader, Polyline, Label } from '@uiw/react-baidu-map';

const TrackMap = (props) => {
    const { qcode, events } = props

    const getPath = () => {
        var path = []
        props.events.map((e) => {
            if (Object.keys(e).includes("lat")) {
                path.push({ lng: e.lon, lat: e.lat })
            }
            return ""
        });
        return path
    }

    const getCenter = (path) => {
        var centerLat = 0, centerLon = 0
        for (var i = 0; i < path.length; i++) {
            centerLat += path[i].lat
            centerLon += path[i].lng
        }
        centerLat = centerLat / path.length
        centerLon = centerLon / path.length
        return { lng: centerLon, lat: centerLat };
    }

    const path = getPath()
    return (
        <div>
            {path.length > 1 ?
                <Row align='middle' justify='center'>
                    <div style={{ width: '65vw', height: '60vh' }}>
                        <APILoader akay="PBY8a0Srye77leaBnETSUiuGGmARNiTj">
                            <Map key={qcode} center={getCenter(path)} zoom={1}>
                                {events.map((e, index) =>
                                    Object.keys(e).includes("lat") ?
                                        <div>
                                            <Marker key={"M"+qcode + e.key} position={{ lng: e.lon, lat: e.lat }} type={index === 0 ? "loc_red" : "loc_blue"} title={e.event} />
                                            <Label key={"L"+qcode + e.key} position={{ lng: e.lon, lat: e.lat }} content={e.startTime}></Label>
                                        </div>
                                        : ''
                                )}
                                <Polyline key={qcode} enableEditing={false} strokeOpacity={1} path={path}/> </Map>
                        </APILoader>
                    </div>
                </Row>
                : ''
            }
        </div>
    )

}

export default TrackMap;